import React from "react";

import Products from "../Products/Products";

const Home = () => {
  return (
    <div>
      <Products></Products>
    </div>
  );
};

export default Home;
